import Sso from '@/models/sso'

export function createUserSession() {
  return Sso.CreateUserSession()
}
